import styled from 'styled-components';
import {rem} from 'polished';

const S = {};
const baseFont = `12px`;

S.AccountSessionTimer = styled.div`
  display: flex;
  color: ${({theme: {$accountTopHeaderColor}}) => $accountTopHeaderColor};
  padding: 0;
`;

S.TimeParts = styled.span`
  display: flex;
  margin-right: 0.2rem;
  font-size: 0.8rem;
`;

export default S;